import { useBCMSContext, useBCMSModal } from "@bcm-dev/bcms-vite";
import UINotifiButton from 'components/shared/notifi/UINotifiButton';
import { ContactInfo } from 'model';
import React from 'react';
import CustomModal, { CustomModalContent, CustomModalFooter } from '../..';
import "./styles.css";

/**
 * @function DeletePhoneModal
 * @return {React.Component}
 * @exported true
 * @description The main component for the DeletePhoneModal
 */
export default function DeletePhoneModal(props) {
  const { info, refresh } = props.data ?? {};
  
  const { close } = useBCMSModal();
  const globalController = useBCMSContext();

  const deleteContactInfo = evt => {
    ContactInfo.setNextContactInfoInArrayAsPrimary(info, globalController);

    close("DeletePhoneModal");
    refresh();
  };
  const closeModal = evt => close("DeletePhoneModal");

  return (
    <CustomModal title="Delete Phone Number" id="DeletePhoneModal" className="delete-phone-modal mobile-view-modal">
      <CustomModalContent>
        <p>Are you sure you want to delete the Phone Number '{ info.value }'?</p>
      </CustomModalContent>
      <CustomModalFooter>
        <UINotifiButton text="Cancel" className="ui-notifi-secondary-modal-button" onClick={ closeModal } />
        <UINotifiButton text="Delete" onClick={ deleteContactInfo } />
      </CustomModalFooter>
    </CustomModal>
  );
}
